import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { Card } from "../../ui";
import Logo from "./Logo";
import SiteBackdrop from "./SiteBackdrop";

// Shell for login, sign-up, password reset and account deletion: slim top
// bar, a title, and one centered card.
const AuthLayout = ({ title, subtitle, children, footer, wide = false }) => (
  <div dir="rtl" className="relative isolate min-h-screen overflow-hidden bg-header font-sans text-white">
    <SiteBackdrop />
    <header className="relative z-10">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <Logo to="/" className="w-11 h-11" />
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-white/70 hover:text-white"
        >
          <FaArrowRight className="text-xs" aria-hidden="true" />
          الرئيسية
        </Link>
      </div>
    </header>

    <main className="relative z-10 px-4 pt-6 pb-16 md:pt-10">
      <div className={`mx-auto w-full ${wide ? "max-w-lg" : "max-w-md"}`}>
        {(title || subtitle) && (
          <div className="text-center mb-6">
            {title && (
              <h1 className="text-2xl md:text-3xl font-extrabold">{title}</h1>
            )}
            {subtitle && (
              <p className="text-white/70 mt-2 leading-relaxed">{subtitle}</p>
            )}
          </div>
        )}
        <Card tone="solid" pad="lg" className="shadow-2xl shadow-black/30">
          {children}
        </Card>
        {footer && (
          <div className="text-center text-sm text-white/70 mt-6">{footer}</div>
        )}
      </div>
    </main>
  </div>
);

// Inline text link styled for the auth pages.
export const AuthLink = ({ to, state, children }) => (
  <Link
    to={to}
    state={state}
    className="font-bold text-primary hover:text-mainText underline-offset-4 hover:underline"
  >
    {children}
  </Link>
);

export default AuthLayout;
